function Hero() {
  return (
    <div className="min-h-screen bg-navy flex flex-col items-center justify-center text-white px-8">
      <p className="text-green font-mono mb-4">Hi, my name is</p>
      <h1 className="text-6xl font-bold text-slate-light mb-4">Digamber Dwivedi</h1>
      <h2 className="text-4xl font-bold text-slate mb-6">Cloud Operations Engineer</h2>
      <p className="text-slate max-w-xl text-center mb-10">
        Building reliable systems on AWS and Kubernetes. 
        10+ years in production reliability, observability, and incident management.
      </p>
      <div className="flex gap-6">
        <a href="mailto:digamdip@gmail.com" 
           className="border border-green text-green px-8 py-3 rounded hover:bg-green hover:text-navy transition-all">
          Get In Touch
        </a>
        <a href="https://github.com/digamber-dwivedi" target="_blank" rel="noreferrer"
           className="border border-slate text-slate px-8 py-3 rounded hover:border-green hover:text-green transition-all">
          GitHub
        </a>
      </div>
    </div>
  );
}

export default Hero;